<template>
  <transition name="dialog-fade" @after-leave="afterLeave">
    <div v-show="visible" class="el-dialog__wrapper" @click.self="handleWrapperClick">
      <div
        ref="dialog"
        class="el-dialog"
        qaid="el-dialog"
        :class="[
          {
            'is-fullscreen': fullscreen,
            'text-center': center,
          },
          customClass,
        ]"
        :style="style"
      >
        <div class="el-dialog__header" :class="[headerClass, {'pr-6': showClose}]">
          <slot name="title">
            <span class="el-dialog__title heading heading--md" qaid="dialog-title">{{ title }}</span>
          </slot>
          <trek-button
            v-if="showClose"
            text
            icon-only
            icon="close"
            class="el-dialog__close"
            :aria-label="closeDialogToolTip"
            qaid="dialog-close"
            @click="handleClose"
          >
          </trek-button>
        </div>

        <div v-if="rendered" class="el-dialog__body" :class="[bodyClass]">
          <slot></slot>
        </div>

        <div v-if="$slots.footer" class="el-dialog__footer" :class="[footerClass]">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Popup from '../utils/popup';
import emitter from '../mixins/emitter';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'ElDialog',
  components: {TrekButton},
  mixins: [Popup, emitter],
  props: {
    title: {
      type: String,
      default: '',
    },
    modal: {
      type: Boolean,
      default: true,
    },
    modalAppendToBody: {
      type: Boolean,
      default: true,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    lockScroll: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: undefined,
    },
    fullscreen: Boolean,
    customClass: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
    bodyClass: {
      type: String,
      default: '',
    },
    footerClass: {
      type: String,
      default: '',
    },
    top: {
      type: String,
      default: '15vh',
    },
    beforeClose: {
      type: Function,
      default: undefined,
    },
    center: {
      type: Boolean,
      default: false,
    },
    closeDialogToolTip: {
      type: String,
      default: 'Close',
    },
  },
  data() {
    return {
      closed: false,
    };
  },
  computed: {
    style() {
      let style = {};
      if (!this.fullscreen) {
        style.marginTop = this.top;
        if (this.width) {
          style.width = this.width;
        }
      }
      return style;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.closed = false;
        this.$emit('open');
        this.$el.addEventListener('scroll', this.updatePopper);
        this.$nextTick(() => {
          this.$refs.dialog.scrollTop = 0;
        });
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      } else {
        this.$el.removeEventListener('scroll', this.updatePopper);
        if (!this.closed) this.$emit('close');
      }
    },
  },
  mounted() {
    if (this.visible) {
      this.rendered = true;
      this.open();
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose();
    },
    handleClose() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    hide(cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('close');
        this.closed = true;
      }
    },
    updatePopper() {
      this.broadcast('ElSelectDropdown', 'updatePopper');
      this.broadcast('ElDropdownMenu', 'updatePopper');
    },
    afterLeave() {
      this.$emit('closed');
    },
  },
};
</script>
